/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutConfirmModalComponent } from '@layout/confirm-modal/confirm-modal.component';
import { DatalistAnagrafica, Opera, Rilievo } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RilievoService } from '@shared/services/rilievo.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-dettaglio-rilievo',
    templateUrl: './dettaglio-rilievo.component.html'
})
export class PagesGestioneRilievoDettaglioRilievoComponent implements OnInit {

    public rilievo: Rilievo;
    public criteriaForm: FormGroup;
    public datalist: DatalistAnagrafica;
    public opereAssociateList: Opera[] | any = [];

    constructor(
        private rilievoService: RilievoService,
        private utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.rilievo = this.route.snapshot.data['additionalInformation'].rilievo;
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
        this.opereAssociateList = this.route.snapshot.data['additionalInformation'].opereAssociate;
        this.criteriaForm = this.rilievoService.generateFormRilievo(this.rilievo);
    }

    public goToModifica() {
        this.router.navigate(['modifica'], { relativeTo: this.route });
    }

    public deleteRilievo() {
        const modal = this.modalService.open(LayoutConfirmModalComponent,{size: 'xs'});
        modal.componentInstance.description = 'il Rilievo selezionato e le associazioni appartenenti ad esso verranno eliminate, si vuole procedere comunque? Si consiglia di eliminare l\'opera per eventuali errori di associazione.'
        modal.componentInstance.confirm = () => {
            this.rilievoService.delete(this.rilievo.idRilievo).subscribe(response => {
                if (this.utilsService.genericResponse204NoContent(response)) {
                    this.router.navigate(['..'], { relativeTo: this.route });
                }
            });
        };

    }

}
